import { ff } from '@atlassian/jira-feature-flagging';

export const isJsmFixIncompatibleRequestTypeInconsistenciesEnabled = () =>
	ff('jsm-fix-invalid-request-type-inconsistencies_x7maw', false);
